import React, { useEffect, useState } from "react";
import axios from "axios";
import Servidor from "../config/Servidor";
import { useNavigate } from "react-router-dom";

export default function MisCobradores() {
  const user = JSON.parse(localStorage.getItem("user"));
  const [cobradores, setCobradores] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const navigate = useNavigate();

  const [modal, setModal] = useState({
    visible: false,
    cobrador: null,
  });

  useEffect(() => {
    if (!user) return;

    axios
      .get(`${Servidor.IP}/usuarios/cobradores-completos/${user.id_usuario}`)
      .then((res) => {
        if (res.data.ok) {
          setCobradores(res.data.cobradores);
        }
      })
      .catch((err) => {
        console.log(err);
        alert("Error al cargar cobradores");
      });
  }, []);

  const formatearFecha = (fecha) => {
    if (!fecha) return "-";
    const d = new Date(fecha);
    return d.toLocaleString("es-BO", { timeZone: "America/La_Paz" });
  };

  const filtrados = cobradores.filter((c) => {
    const nombreCompleto = c.persona
      ? `${c.persona.nombre} ${c.persona.primerapellido} ${c.persona.segundoapellido || ""}`
      : "";
    const otrosSupervisores =
      c.supervisores?.filter((s) => s.id_usuario !== user.id_usuario) || [];

    const socioTexto =
      otrosSupervisores.length > 0
        ? otrosSupervisores.map((s) => s.persona_nombre || s.usuario).join(", ")
        : "-";

    const textoFila = [
      nombreCompleto,
      c.info_usuario.id_usuario,
      c.info_usuario.usuario,
      socioTexto,
      c.caja?.ultima_fecha_liquidada
        ? formatearFecha(c.caja.ultima_fecha_liquidada)
        : "-",
    ]
      .join(" ")
      .toLowerCase();

    return textoFila.includes(busqueda.toLowerCase());
  });

  const abrirConfirmacion = (cobrador) => {
    setModal({
      visible: true,
      cobrador,
    });
  };

  const confirmarRevision = () => {
    navigate("/listaclientes", { state: { cobrador: modal.cobrador } });
  };

  return (
    <div style={{ padding: 10 }}>
      {/*
      <button
        onClick={() => navigate("/principal")}
        style={{
          background: "#3498db",
          color: "white",
          border: "none",
          padding: "8px 12px",
          borderRadius: 6,
          cursor: "pointer",
          marginBottom: 15,
        }}
      >
        ⬅ Volver
      </button>
      */}
{/* NAV SUPERIOR RESPONSIVE */}
<div
  style={{
    width: "100%",
    maxWidth: "100%",
    background: "#0740A0",
    color: "white",
    padding: "12px 16px",
    borderRadius: "8px",
    marginBottom: "20px",
    boxSizing: "border-box",
    overflow: "hidden",
    wordWrap: "break-word",
  }}
>
  <h2
    style={{
      margin: 0,
      fontSize: "clamp(16px, 4vw, 20px)", // Se ajusta según pantalla
      fontWeight: "bold",
      lineHeight: 1.2,
    }}
  >
    Hola {user.persona_nombre || user.usuario}
  </h2>

  <p
    style={{
      margin: "4px 0 0 0",
      fontSize: "clamp(12px, 3vw, 15px)", // También responsivo
      opacity: 0.95,
      lineHeight: 1.2,
    }}
  >
  </p>
</div>

  <p style={{ color: "#0740A0" }}>Lista de Cobros </p>
   
    {/* Buscador */}
<input
  type="text"
  placeholder="Buscar..."
  value={busqueda}
  onChange={(e) => setBusqueda(e.target.value)}
  style={{
    padding: "8px",
    marginBottom: 15,
    width: "100%",        // PC → 100%
    maxWidth: "100%",     // PC → que no se limite
    borderRadius: 6,
    border: "1px solid #ccc",
    display: "block",
  }}
/>


      {filtrados.length === 0 ? (
        <p style={{ color: "red" }}>No cuenta con cobradores</p>
      ) : (
        /* 📌 CONTENEDOR CON SCROLL SOLO EN CELULAR */
          <div
        style={{
          overflowX: "auto",
          borderRadius: 6,
          border: "1px solid #ddd",
          paddingBottom: 5,
        }}
      >
      {/* TABLA */} 
<div
  style={{
    maxHeight: "65vh",
    overflowY: "auto",
    overflowX: "auto",
    border: "1px solid #ddd",
    borderRadius: 8,

  }}
>
          <table
            style={{
              minWidth: "900px",
              width: "100%",
              borderCollapse: "collapse",
              background: "white",
            }}
          >
            <thead style={{ background: "#0740A0", color: "white" }}>
              <tr>
                <th style={{ padding: 10 }}>Acción</th>
                <th style={{ padding: 10 }}>Cobrador</th>
                <th style={{ padding: 10 }}>Código</th>
                <th style={{ padding: 10 }}>Usuario</th>
                <th style={{ padding: 10 }}>Supervisor</th>
                <th style={{ padding: 10 }}>Última Liquidada</th>
              </tr>
            </thead>

            <tbody>
              {filtrados.map((c) => {
                const nombreCompleto = c.persona
                  ? `${c.persona.nombre} ${c.persona.primerapellido} ${c.persona.segundoapellido || ""}`
                  : "-";

                const otrosSupervisores =
                  c.supervisores?.filter((s) => s.id_usuario !== user.id_usuario) ||
                  [];

                const socioTexto =
                  otrosSupervisores.length > 0
                    ? otrosSupervisores
                        .map((s) => s.persona_nombre || s.usuario)
                        .join(", ")
                    : "-";

                return (
                  <tr key={c.info_usuario.id_usuario}>
                    <td style={{ padding: 10, textAlign: "center" }}>
                      <span
                        onClick={() => abrirConfirmacion(c)}
                        style={{
                          cursor: "pointer",
                          fontSize: 20,
                          color: "#2980b9",
                        }}
                      >
                        🔍
                      </span>
                    </td>
                    <td style={{ padding: 10 }}>{nombreCompleto}</td>
                    <td style={{ padding: 10 }}>{c.info_usuario.id_usuario}</td>
                    <td style={{ padding: 10 }}>{c.info_usuario.usuario}</td>
                    <td style={{ padding: 10 }}>{socioTexto}</td>
                    <td style={{ padding: 10 }}>
                      {c.caja?.ultima_fecha_liquidada
                        ? formatearFecha(c.caja.ultima_fecha_liquidada)
                        : "-"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
      </div>


      </div>
      )}

      {/* MODAL */}
      {modal.visible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "white",
              padding: 25,
              borderRadius: 8,
              width: "90%",
              maxWidth: 400,
            }}
          >
            <h3 style={{ marginBottom: 20 }}>
              ¿Deseas confirmar la revisión de{" "}
              <span style={{ color: "#0740A0" }}>
                {modal.cobrador.persona.nombre}{" "}
                {modal.cobrador.persona.primerapellido}
              </span>
              ?
            </h3>

            <button
              onClick={confirmarRevision}
              style={{
                background: "#2ecc71",
                color: "white",
                padding: "10px 15px",
                border: "none",
                borderRadius: 6,
                cursor: "pointer",
                width: "100%",
                marginBottom: 10,
              }}
            >
              Sí, confirmar
            </button>

            <button
              onClick={() => setModal({ visible: false, cobrador: null })}
              style={{
                background: "#e74c3c",
                color: "white",
                padding: "10px 15px",
                border: "none",
                borderRadius: 6,
                cursor: "pointer",
                width: "100%",
              }}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
